module.exports = __webpack_public_path__ + "img/icon-email-code.501f5e3a.png";